import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AppState } from '@auth0/auth0-angular';
import { NgbModal, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { Store } from '@ngrx/store';
import { CookieService } from 'ngx-cookie-service';
import { AlertService } from 'src/app/core/services/AlertService/alert.service';
import { AuthenticationService } from 'src/app/core/services/auth.service';
import { ApiService } from 'src/app/services/api';
import { BreadcrumbService } from 'src/app/services/breadcrumb';

@Component({
  selector: 'app-plan-pricing',
  templateUrl: './plan-pricing.component.html',
  styleUrls: ['./plan-pricing.component.scss']
})
export class PlanPricingComponent implements OnInit {
  plans: any[] = [];
  GLOBALURL: string;
  headerToken = {
    "Content-Type": "application/json",
    Authorization: this.cookieService.get("token"),
  };
  constructor(
    private cookieService: CookieService,
    public http: HttpClient,
    private toastr: AlertService,
    private store: Store<AppState>,
    public router: Router,
    public route: ActivatedRoute,
    private modalConfig: NgbModalConfig,
    private modalService: NgbModal,
    private ApiService: ApiService,
    private BreadcrumbService: BreadcrumbService,
    private authService: AuthenticationService,
  ) {
    this.GLOBALURL = this.ApiService.getBaseURL();
   }

  ngOnInit(): void {
    this.fetchPlans();
  }
 

  fetchPlans() {
    // const params = new HttpParams().set('driverId', this.driverId);
    return this.http
      .get(`${this.GLOBALURL}/plans`, {
        headers: new HttpHeaders({
          "Content-Type": "application/json",
          Authorization: this.cookieService.get("token"),
        }),
        // params: params
      })
      .subscribe((response: any) => {
        if (response.success) {
          // this.store.dispatch(setLoadingSpinner({ status: false }));
          this.plans = response.response;
          
        } else {
          this.toastr.error(response.message);
          // this.store.dispatch(setLoadingSpinner({ status: false }));
        }
      })
      // .catch((error) => {
      //   this.toastr.error("Failed to load driver data.");
      //   // this.store.dispatch(setLoadingSpinner({ status: false }));
      //   return null;
      // });
  }
}
